var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStreamlineIconBookReadHuman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.25,
    height: 18,
    viewBox: "0 0 17.25 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.87,
    x2: 0.5,
    y2: 0.087,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#137ac9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#039fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    y1: 0.858,
    x2: 0.5,
    y2: 0.074,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.5,
    y1: 0.908,
    x2: 0.5,
    y2: 0,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-read-human_24x24",
    "data-name": "streamline-icon-read-human@24x24",
    transform: "translate(-2.125 -3.751)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M5,18.807v.939a.857.857,0,0,0,.486.833l5.707,1.983V14.271L5.847,12.043a.615.615,0,0,0-.614.156A.823.823,0,0,0,5,12.864v1.731",
    transform: "translate(-0.138 -0.811)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M18.8,18.666v1.086a.851.851,0,0,1-.493.833L12.5,22.562V14.271l5.439-2.227a.631.631,0,0,1,.624.156.815.815,0,0,1,.237.664V14.73",
    transform: "translate(-1.446 -0.811)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M6.258,18.137c0,.469-.528.845-1.174.838-1.293-.006-2.338-.766-2.334-1.7v-.845c0-.932,1.056-1.683,2.347-1.677.647,0,1.169.383,1.167.845Z",
    transform: "translate(0 -0.936)",
    fill: "none",
    stroke: "#eaf1f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M17.757,18.137c0,.469.528.845,1.176.838,1.3-.006,2.342-.766,2.337-1.7v-.845c0-.932-1.058-1.683-2.353-1.677-.647,0-1.171.383-1.168.845Z",
    transform: "translate(-2.52 -0.936)",
    fill: "none",
    stroke: "#eaf1f8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M8.387,4.623A3.872,3.872,0,1,0,12.259.751,3.872,3.872,0,0,0,8.387,4.623Z",
    transform: "translate(-1.205 3)",
    fill: "url(#linear-gradient-3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamlineIconBookReadHuman);
export default __webpack_public_path__ + "static/media/streamline-icon-book-read-human.53d97bc0.svg";
export { ForwardRef as ReactComponent };